import {MuWidget} from "mu-widget/lib/MuWidget";
import {PlanItem} from "../types";
import {PlanItemRepeatingUtil} from "../PlanItemRepeatingUtil";
import {PlanItems} from "./admin/PlanItems";
import {MuBinder} from "mu-widget/lib/MuBinder";

export class UiCalendar extends MuWidget {
    public data: PlanItem[] = [];
    public timeGranularity: number = 3600;
    public usualDayBegin = 7 * 3600;
    public usualDayEnd = 20 * 3600;
    public render(): void
    {
        this.container.innerHTML = '';
        const itemsBy= PlanItemRepeatingUtil.groupedForCalendar(this.data, this.timeGranularity);
        let dayBegin = this.usualDayBegin;
        let dayEnd = this.usualDayEnd;
        this.data.forEach((item) => {
            dayBegin = Math.min(item.repeating.secondsAM, dayBegin);
            dayEnd = Math.max(item.repeating.secondsAM, dayEnd);
        });

        dayBegin = Math.floor(dayBegin / this.timeGranularity) * this.timeGranularity;
        dayEnd = Math.floor(dayEnd / this.timeGranularity) * this.timeGranularity;

        for(let week = 1; week <= 2; week++) {
            this.muCreateWidget('UiCalendarDay', this.container, { name: "Týden " + week });
            for (const dayName of PlanItemRepeatingUtil.dayNames) {
                this.muCreateWidget('UiCalendarDay', this.container, { name: dayName });
            }
            for (let sam = dayBegin; sam <= dayEnd; sam += this.timeGranularity) {
                this.muCreateWidget('UiCalendarTime', this.container, { secondsAM: sam });
                for (let dayNum = 0; dayNum < 7; dayNum++) {
                    this.muCreateWidget('UiCalendarBlock', this.container, {
                        secondsAM: sam,
                        dayNum: dayNum,
                        week: week,
                        items: itemsBy[PlanItemRepeatingUtil.calendarBlockKey(week, dayNum, sam)] ?? []
                    });
                }
            }
        }
    }

    beforeIndex() {
        this.container.classList.add('ui-calendar');
    }
}

export class UiCalendarDay extends MuWidget {
    public name: string = '';
    beforeIndex() {
        this.container.classList.add('ui-calendar__day');
    }
    afterIndex() {
        this.container.textContent = this.name;
    }
}

export class UiCalendarTime extends MuWidget {
    public secondsAM: number = 0;
    beforeIndex() {
        this.container.classList.add('ui-calendar__time');
    }

    afterIndex() {
        this.container.textContent = PlanItemRepeatingUtil.formatSecondsAM(this.secondsAM);
    }
}

export class UiCalendarBlock extends MuWidget {
    public dayNum: number = 0;
    public secondsAM: number = 0;
    public items: PlanItem[] = [];
    public week: string = "";
    // @ts-ignore
    muParent: UiCalendar

    beforeIndex() {
        this.container.classList.add('ui-calendar__block');
        this.muAppendContent(`
            <div class="ui-calendar__block__items" mu="items">
                <div mu=":UiCalendarItem@item" class="ui-calendar__block__item">
                    <span mu="#repeating|getField('secondsAM')|dayTime"></span>
                    <span mu="#icon|prepend('icon--'):className"></span>
                    <strong mu="#activity"></strong>
                    <span mu="#activityVariant"></span>
                    <span mu="value"></span>
                    <em mu="#note"></em>
                </div>
            </div>
            <div class="ui-calendar__block__add" mu="bAdd">+</div>
        `);
    }

    afterIndex() {
        for (const item of this.items) {
            this.muWidgetFromTemplate('item', 'items')
                .muBindData(item);
        }
    }

    bAdd_click() {
        (this.muParent.muParent as unknown as PlanItems).newItem({
            repeating: {
                dayOfWeek: [ this.dayNum ],
                weekMod: this.week,
                secondsAM: this.secondsAM,
            }
        });
    }
}

export class UiCalendarItem extends MuWidget {
    // @ts-ignore
    public item: PlanItem;
    protected muAfterBindData(data: PlanItem) {
        this.item = data;
        this.ui.value.textContent = data.useTimeWatcher
            ? MuBinder.filters.duration(data.value)
            : data.value + (data.unit ?? '');
    }

    container_click() {
        (this.muParent.muParent.muParent as unknown as PlanItems).openEditor(this.item);
    }
}